export const DEFAULT_SELECT_LIMIT = 200;
export const LARGE_SELECT_LIMIT = 500;
export const EXTENDED_SELECT_LIMIT = 2000;
